import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Reset scroll position to the top immediately without transition
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
